// extracted by mini-css-extract-plugin
export default {"eventEdit":"event_eventEdit__a9wCZ"};